import { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import { IoMdAdd } from "react-icons/io";
import Button from "../../Components/Button/index.jsx";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

export default function CreateSessionUI() {
  const navigate = useNavigate();

  const [name, setName] = useState("");

  const [brand, setBrand] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [factory, setFactory] = useState([]);

  const [brandsList, setBrandsList] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);
  const [factoriesList, setFactoriesList] = useState([]);

  const [backgroundColor, setBackgroundColor] = useState("#ffffff");
  const [tileFocusColor, setTileFocusColor] = useState("#ffffff");
  const [orbFocusColor, setOrbFocusColor] = useState("#ffffff");

  const [brandLogoFile, setBrandLogoFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const [sessionId, setSessionId] = useState(null);

  //   const fetchExistingSessionUI = async () => {
  //   const { data, error } = await supabase
  //     .from("sessionUI")
  //     .select("*")
  //     .order("id", { ascending: false })
  //     .limit(1)
  //     .single();

  //   if (error || !data) return;

  //   // Fill state
  //   setName(data.name || "");
  //   setBrand(data.brand || []);
  //   setVendor(data.vendor || []);
  //   setFactory(data.factory || []);
  //   setBackgroundColor(data.background_color || "#ffffff");
  //   setTileFocusColor(data.tile_focus_color || "#ffffff");
  //   setOrbFocusColor(data.orb_focus_color || "#ffffff");

  //   // Brand logo: you have URL only → preview later if needed
  //   // No need to set file here because we can't reconstruct File object
  // };

  // ========== FETCH DROPDOWN DATA ==========

  const fetchExistingSessionUI = async () => {
    const { data, error } = await supabase
      .from("sessionUI")
      .select("*")
      .order("id", { ascending: false })
      .limit(1)
      .single();

    if (error || !data) return;

    setSessionId(data.id); // ✅ NEW LINE

    setName(data.name || "");
    setBrand(data.brand || []);
    setVendor(data.vendor || []);
    setFactory(data.factory || []);
    setBackgroundColor(data.background_color || "#ffffff");
    setTileFocusColor(data.tile_focus_color || "#ffffff");
    setOrbFocusColor(data.orb_focus_color || "#ffffff");
  };

  const fetchDropdowns = async () => {
    const brandRes = await supabase.from("Brand").select("*");
    const vendorRes = await supabase.from("Vendor").select("*");
    const factoryRes = await supabase.from("Factory").select("*");

    setBrandsList(brandRes.data || []);
    setVendorsList(vendorRes.data || []);
    setFactoriesList(factoryRes.data || []);
  };

  useEffect(() => {
    fetchDropdowns();
  }, []);

  // ========== FILE UPLOAD ==========
  const uploadBrandLogo = async () => {
    if (!brandLogoFile) return null;

    const fileName = `logo-${Date.now()}-${brandLogoFile.name}`;
    const { error } = await supabase.storage
      .from("sessionui-logos")
      .upload(fileName, brandLogoFile);

    if (error) {
      console.error("Upload failed:", error);
      return null;
    }

    const { data: urlData } = supabase.storage
      .from("sessionui-logos")
      .getPublicUrl(fileName);

    return urlData.publicUrl;
  };

  // ========== SAVE SESSION UI ==========
  const handleSave = async () => {
    if (!name.trim()) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Name is required",
        toast: true,
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    setLoading(true);
    const logoUrl = await uploadBrandLogo();

    // const { error } = await supabase.from("sessionUI").insert([
    //   {
    //     name,
    //     brand,
    //     vendor,
    //     factory,
    //     background_color: backgroundColor,
    //     tile_focus_color: tileFocusColor,
    //     orb_focus_color: orbFocusColor,
    //     brand_logo_url: logoUrl || null,
    //   },
    // ]);

    const payload = {
      name,
      brand,
      vendor,
      factory,
      background_color: backgroundColor,
      tile_focus_color: tileFocusColor,
      orb_focus_color: orbFocusColor,
      ...(logoUrl ? { brand_logo_url: logoUrl } : {}), // keep old logo if no new uploaded
    };

    let result;

    if (sessionId) {
      // 🔥 UPDATE EXISTING (NO DUPLICATES)
      result = await supabase
        .from("sessionUI")
        .update(payload)
        .eq("id", sessionId);
    } else {
      // 🔥 FIRST TIME → INSERT
      result = await supabase.from("sessionUI").insert([payload]);
    }

    const { error } = result;

    setLoading(false);

    if (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Failed to save Skin UI",
        toast: true,
        timer: 2500,
        showConfirmButton: false,
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Skin UI saved successfully",
        toast: true,
        timer: 2500,
        showConfirmButton: false,
      });
      navigate("/session-ui");
    }
  };

  // ========== MAPPING FOR react-select ==========
  const brandOptions = brandsList.map((b) => ({
    value: b.id,
    label: b.name,
  }));

  const vendorOptions = vendorsList.map((v) => ({
    value: v.id,
    label: v.name,
  }));

  const factoryOptions = factoriesList.map((f) => ({
    value: f.id,
    label: f.name,
  }));

  useEffect(() => {
    fetchDropdowns();
    fetchExistingSessionUI();
  }, []);

  return (
    <div className="h-screen p-6 bg-white">
      <h1 className="text-3xl font-semibold uppercase font-serif mb-4">
        Create Skin UI
      </h1>

      {/* FORM WRAPPER */}
      <div className="border border-gray-300 rounded-md p-6 h-[calc(100vh-8rem)] overflow-auto bg-white space-y-6">
        {/* Name */}
        <div>
          <label className="block mb-1 font-semibold">Name</label>
          <input
            type="text"
            className="w-full border px-3 py-2 rounded-md"
            placeholder="Enter session name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {/* Multi Selects (Brand/Vendor/Factory) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block mb-1 font-semibold">Brand</label>
            <Select
              isMulti
              options={brandOptions}
              value={brandOptions.filter((opt) => brand.includes(opt.value))}
              onChange={(vals) => setBrand(vals.map((v) => v.value))}
            />
          </div>

          <div>
            <label className="block mb-1 font-semibold">Vendor</label>

            <Select
              isMulti
              options={vendorOptions}
              value={vendorOptions.filter((opt) => vendor.includes(opt.value))}
              onChange={(vals) => setVendor(vals.map((v) => v.value))}
            />
          </div>

          <div>
            <label className="block mb-1 font-semibold">Factory</label>

            <Select
              isMulti
              options={factoryOptions}
              value={factoryOptions.filter((opt) =>
                factory.includes(opt.value),
              )}
              onChange={(vals) => setFactory(vals.map((v) => v.value))}
            />
          </div>
        </div>

        {/* COLORS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block mb-1 font-semibold">Background Color</label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={backgroundColor}
                onChange={(e) => setBackgroundColor(e.target.value)}
                className="w-12 h-12 border rounded-md"
              />
              <input
                type="text"
                value={backgroundColor}
                onChange={(e) => setBackgroundColor(e.target.value)}
                className="border rounded-md px-3 py-2 w-full"
              />
            </div>
          </div>

          <div>
            <label className="block mb-1 font-semibold">Tile Focus Color</label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={tileFocusColor}
                onChange={(e) => setTileFocusColor(e.target.value)}
                className="w-12 h-12 border rounded-md"
              />
              <input
                type="text"
                value={tileFocusColor}
                onChange={(e) => setTileFocusColor(e.target.value)}
                className="border rounded-md px-3 py-2 w-full"
              />
            </div>
          </div>

          <div>
            <label className="block mb-1 font-semibold">Orb Focus Color</label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={orbFocusColor}
                onChange={(e) => setOrbFocusColor(e.target.value)}
                className="w-12 h-12 border rounded-md"
              />
              <input
                type="text"
                value={orbFocusColor}
                onChange={(e) => setOrbFocusColor(e.target.value)}
                className="border rounded-md px-3 py-2 w-full"
              />
            </div>
          </div>
        </div>

        {/* Brand Logo Upload */}
        <div>
          <label className="block mb-1 font-semibold">Brand Logo</label>
          <input
            type="file"
            accept="image/*"
            className="w-full border px-3 py-2 rounded-md"
            onChange={(e) => setBrandLogoFile(e.target.files?.[0] || null)}
          />
        </div>
      </div>

      {/* BOTTOM SAVE BUTTON (same as SelectPage) */}
      <Button
        variant="success"
        onClick={handleSave}
        className="px-5 py-1 my-2 text-sm flex items-center gap-3 mx-auto"
      >
        {loading ? "Saving..." : "Save"}
      </Button>
    </div>
  );
}
